import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export const formatMillisecondsToTime = (milliseconds = 0) => {
  // Convert milliseconds to hours, minutes, and seconds
  const hours = Math.floor(milliseconds / (1000 * 60 * 60));
  const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);

  // Pad single digit hours, minutes, and seconds with leading zeros
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');

  // Combine hours, minutes, and seconds into a time string format '00:00:00'
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const formatDateToTime = (date) => {
  if (!(date instanceof Date)) return '00:00:00';

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  // Pad single digit hours, minutes, and seconds with leading zeros
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');

  // Combine hours, minutes, and seconds into a time string format '00:00:00'
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const formatSecondesToHourMinute = (seconds) => {
  seconds = Math.round(Number(seconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  const paddedHours = hours.toString().padStart(2, '0');
  const paddedMinutes = minutes.toString().padStart(2, '0');

  return `${paddedHours}h : ${paddedMinutes}m`;
};

export const formatTime = (seconds) => {
  if (!seconds || seconds <= 0) return '—';

  const totalMinutes = Math.floor(seconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
};

export const getTimeDifference = (plannedHours, spentSeconds) => {

  if (!plannedHours) {
    return { label: '—', isOver: false };
  }

  const plannedMinutes = plannedHours * 60;
  const spentMinutes = Math.floor(spentSeconds / 60);

  const diffMinutes = spentMinutes - plannedMinutes;
  const absMinutes = Math.abs(diffMinutes);

  const hours = Math.floor(absMinutes / 60);
  const minutes = absMinutes % 60;

  const label = hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;

  return {
    label,
    isOver: diffMinutes > 0, // true = exceeded planned time
  };
};

export const formatDecimalHours = (decimalHours) => {
  if (decimalHours == null || Number.isNaN(decimalHours)) return '—';

  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);

  if (hours === 0 && minutes === 0) return '0m';
  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;

  return `${hours}h ${minutes}m`;
};

